import { render, staticRenderFns } from "./T1ResultsOfferCard.vue?vue&type=template&id=20336660&scoped=true&"
import script from "./T1ResultsOfferCard.vue?vue&type=script&lang=js&"
export * from "./T1ResultsOfferCard.vue?vue&type=script&lang=js&"
import style0 from "./T1ResultsOfferCard.vue?vue&type=style&index=0&id=20336660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20336660",
  null
  
)

export default component.exports